import React, { Component } from 'react';
import River from '../components/panel/items/filters/filterComponents/River';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import HoverMap from '../components/HoverMap';
import { connect } from 'react-redux';
import * as actions from '../store/actions';
import Plot from 'react-plotly.js';
import axios from 'axios';
import _ from 'underscore';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { DefaultButton, ActionButton } from 'office-ui-fabric-react/lib/Button';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import { buildPor } from '../utilities'
import Loading from '../components/loading';

const INITIAL_QUERY = {
  source: 2,
  river: 1,
  location: 19,
  type: 4,
  baseAlt: 2,
  compAlt: 4
};

class Por extends Component{

  state = {
    initalized: false
  };

  componentDidMount = () => {
    if(this.props.initialVisit){
      this.changeFilter({source: INITIAL_QUERY.source}, 'source');
      this.changeFilter({river: INITIAL_QUERY.river}, 'river');
      this.changeFilter({location: INITIAL_QUERY.location}, 'location');
      this.changeFilter({ ...INITIAL_QUERY }, 'pre-load');
      this.props.editState({initialVisit: false});
      this.applyFilters({
        ...INITIAL_QUERY
      });
    };
  };

  changeFilter = (changes, field) => {

    this.props.editState({
      ...changes
    });

    switch(field){
      case 'favorite': 
        // when we pick a favorite location, we can determin the types that are available
        axios.get(`/api/query/find/types/${changes.location}`)
        .then(response => {
          this.props.editState({availableFilters: {
            ...this.props.availableFilters,
            types: response.data.availableFilters.types
          }})
        })
        .catch(error => {
          this.props.editState({error_message: 'Could not update filters'})
        })
      break;
      case 'source':
        axios.get(`/api/query/find/rivers/${changes.source}`)
        .then(response => {
          this.props.editState({availableFilters: {
            ...this.props.availableFilters,
            rivers: response.data.availableFilters.rivers
          }})
        })
        .catch(error => {
          this.props.editState({error_message: 'Could not update filters'})
        })
        break;
      case 'river':
        axios.get(`/api/query/find/locations/${changes.river}`)
        .then(response => {
          this.props.editState({availableFilters: {
            ...this.props.availableFilters,
            locations: response.data.availableFilters.locations
          }})
        })
        .catch(error => {
          this.props.editState({error_message: 'Could not update filters'})
        })
        break;
      case 'location':
        axios.get(`/api/query/find/types/${changes.location}`)
        .then(response => {
          this.props.editState({availableFilters: {
            ...this.props.availableFilters,
            types: response.data.availableFilters.types
          }})
        })
        .catch(error => {
          this.props.editState({error_message: 'Could not update filters'})
        })
        break;
      case 'type':
        axios.get(`/api/query/find/alternatives/${this.props.source}/${this.props.river}/${this.props.location}/${changes.type}`)
        .then(response => {
          this.props.editState({availableFilters: {
            ...this.props.availableFilters,
            baseAlts: response.data.availableFilters.alternatives,
            compAlts: response.data.availableFilters.alternatives
          }})
        })
        .catch(error => {
          this.props.editState({error_message: 'Could not update filters'})
        })
        break;
      case 'pre-load':
        axios.get(`/api/query/find/alternatives/${changes.source}/${changes.river}/${changes.location}/${changes.type}`)
        .then(response => {
          this.props.editState({availableFilters: {
            ...this.props.availableFilters,
            baseAlts: response.data.availableFilters.alternatives,
            compAlts: response.data.availableFilters.alternatives
          }})
        })
        .catch(error => {
          this.props.editState({error_message: 'Could not update filters'})
        })
        break;
      default: return null
    }
  };

  applyFilters = (queryParams) => {
    let { source, river, type, location, baseAlt, compAlt } = this.props;
    if(queryParams){
      source = queryParams.source;
      river = queryParams.river;
      type = queryParams.type;
      location = queryParams.location;
      baseAlt = queryParams.baseAlt;
      compAlt = queryParams.compAlt;
    };
    if(!source){ return this.props.editState({errorMessage: 'You did not select a source'}) };
    if(!river){ return this.props.editState({errorMessage: 'You did not select a river'}) };
    if(!type){ return this.props.editState({errorMessage: 'You did not select a type'}) };
    if(!location){ return this.props.editState({errorMessage: 'You did not select a location'}) };
    if(!baseAlt){ return this.props.editState({errorMessage: 'You did not select a base alternative'}) };
    if(!compAlt){ return this.props.editState({errorMessage: 'You did not select a base base alternative'}) };

    this.props.editState({
      loadingHeatMap: true,
      errorMessage: null
    });

    axios.get(`/api/query/apply/por/${source}/${river}/${location}/${type}/${baseAlt}&${compAlt}`)
      .then(response => {
        const { data } = response;
        const { result, success } = data;
        if(success && result){
          const sortByName = _.groupBy(result, 'short_name');
          let porData = {};
          Object.keys(sortByName).forEach(key => {
            let grouped = _.groupBy(sortByName[key], 'year');
            porData[key] = grouped;
          });
          let base = this.props.availableFilters.baseAlts.find(({alternative_id}) => alternative_id === baseAlt);
          let comp = this.props.availableFilters.compAlts.find(({alternative_id}) => alternative_id === compAlt);
          let selectedType = this.props.filters.types && this.props.filters.types.filter(({type_id}) => type_id === type)[0];
          let typeText = `${selectedType.type} (${selectedType.unit})`;
          this.props.editState({porDataScale: typeText});
          let plotData = buildPor(porData, base.short_name, comp.short_name, this.props.porDataScale || typeText);
          this.props.editState({
            loadingHeatMap: false,
            data: [plotData],
          })
        } else {
          this.props.editState({loadingHeatMap: false, errorMessage: 'Could not find data for this query', data: []})
        }
      })
      .catch(error => {
        this.props.editState({
          loadingHeatMap: false,
          errorMessage: 'Could not find data for the attempted query...',
          data: []
        })
      });
  };

  render() {
    let filtersFound = this.props.filters.sources;
    const { statsSummary, availableFilters, favorites } = this.props;

    return (
      <div className='container'>
        <Callout hidden={!this.props.hoverMap}>
          <HoverMap {...this.props.hoverMap}/>
        </Callout>
        <div className='heat-map-container default-shadow'>
          {
            this.props.loadingHeatMap ? (
              <Loading blocking label='Loading Heat Map...'/>
            ) : (
              this.props.data && this.props.data.length ? (
                <React.Fragment>
                  {
                    // if there is an error message display at the top
                    this.props.errorMessage && (
                      <div className='message-container'>
                        <MessageBar
                          messageBarType={MessageBarType.error}
                          isMultiline={false}
                          onDismiss={() => this.props.editState({errorMessage: null})}
                          dismissButtonAriaLabel="Close"
                        >
                          { this.props.errorMessage }
                        </MessageBar>
                      </div>
                    )
                  }
                  <Plot
                    onClick={(e) => {
                      const { points } = e;
                      const { x, y, data, pointIndex } = points[0];
                      const comp = data.meta[pointIndex[0]][pointIndex[1]];
                      this.props.editState({statsSummary: {
                        ...comp, 
                        x, 
                        y,
                      }})
                    }}
                    className='plotly-plot'
                    data={this.props.data}
                    config={{
                      displaylogo: false,
                      modeBarButtonsToRemove: ['toImage']
                    }}
                    layout={{
                      autosize: true,
                      yaxis: {
                        autorange: 'reversed',
                        automargin: true,
                      },
                      margin: {
                        l: 60, t: 40, r: 40, b: 75
                      },
                      xaxis: {
                        nticks: 12,
                        automargin: true
                      },
                    }}
                    useResizeHandler={true}
                  />
                  <p className='disclaimer no-shadow'>This version of the HydroViz tool displays the hydrological results of prescriptive modeling the draft Fort Peck Test Release DEIS alternatives over the period of record.  Sharing this tool is intended to facilitate understanding of the alternatives' potential effects in comparison to the existing operation of the system (No Action alternative) and to enable an open, transparent, collaborative discussion among stakeholders. These alternatives represent a range of actions that are being evaluated as part of the NEPA process but it is understood that the agency has not selected any of the potential alternatives. Additionally, potential alternatives may be revised following coordination of the draft EIS with the public, Tribes, agencies, and other stakeholders. These alternatives do not reflect any past, present, or actual operation of the system.  Manipulation of the underlying modeling results would invalidate the depiction of the alternatives' effects.</p>
                </React.Fragment>
              ) : (
                <div className='instructions centered'>Fill out the form...</div>
              )
            )
          }
        </div>
        <div className='right-panel'>
          <div className='heat-map-filters default-shadow'>
            {
              filtersFound && availableFilters ? (
                <div>
                  <ActionButton onClick={() => this.props.editState({favorites: !this.props.favorites})} iconProps={{iconName: favorites ? 'FavoriteStarFill' : 'FavoriteStar'}}>{ favorites ? 'Filter Favorites' : 'Show All'}</ActionButton>
                  {
                    this.props.favorites ? (
                      <Dropdown 
                        label="Location"
                        placeHolder='Select a Location'
                        id='location-dropdown-filter'
                        className={ this.props.souce && this.props.river && this.props.location ? 'heat-map-filter' : 'heat-map-filter empty'}
                        selectedKey={`${this.props.source}-${this.props.river}-${this.props.location}`}
                        onChange={(e, option) => {
                          let { source_id, river_id, location_id } = option;
                          this.changeFilter({source: source_id, river: river_id, location: location_id}, 'favorite')
                        }}
                        options={ this.props.filters && this.props.filters.favorites && this.props.filters.favorites.map(({source, source_id, river, river_id, location, location_id}) => {
                          return {
                            key: `${source_id}-${river_id}-${location_id}`,
                            source_id,
                            river_id,
                            location_id,
                            text: location
                          }
                        }) }
                      />
                    ) : (
                      <div>
                        <Dropdown
                          label="Source:"
                          placeHolder="Select Source"
                          className={ this.props.souce ? 'heat-map-filter' : 'heat-map-filter empty'}
                          id="type-dropdown-filter"
                          selectedKey={this.props.source}
                          onChange={(e, option) => this.changeFilter({source: option.key}, 'source')}
                          options={ this.props.filters.sources.map(({source_id, source}) => ({key: source_id, text: source === 'RIVER' ? 'HEC RAS' : 'RESSIM'})) }
                        />
                        <Dropdown
                          label="River:"
                          placeHolder="Select River"
                          className={ this.props.river ? 'heat-map-filter' : 'heat-map-filter empty'}
                          disabled={!this.props.source}
                          id="river-dropdown-filter"
                          onRenderOption={(props) => <River {...props} />}
                          onDismiss={() => this.props.setMap(null)}
                          selectedKey={this.props.river}
                          onChange={(e, option) => this.changeFilter({river: option.key}, 'river')}
                          options={ availableFilters.rivers.map(({river_id, river, favorite}) => {
                            if(favorites){
                              if(favorite){
                                return ({key: river_id, text: river})
                              } else {
                                return null
                              }
                            } else {
                              return ({key: river_id, text: river})
                            }
                          }).filter(e => e) }
                        />
                        <Dropdown
                          label="Location:"
                          placeHolder="Select Location"
                          className={ this.props.location ? 'heat-map-filter' : 'heat-map-filter empty'}
                          disabled={!this.props.river}
                          id="location-dropdown-filter-single"
                          selectedKey={ this.props.location }
                          onChange={(e, option) => this.changeFilter({location: option.key}, 'location')}
                          options={ availableFilters.locations.map(({location_id, location, favorite}) => {
                            if(favorites){
                              if(favorite){
                                return ({key: location_id, text: location})
                              } else {
                                return null
                              }
                            } else {
                              return ({key: location_id, text: location})
                            }
                          }).filter(e => e)}
                        />
                      </div>
                    )
                  }
                  <Dropdown
                    label="Type:"
                    placeHolder="Select Type"
                    className={ this.props.type ? 'heat-map-filter' : 'heat-map-filter empty'}
                    disabled={!this.props.location}
                    id="type-dropdown-filter"
                    selectedKey={this.props.type}
                    onChange={(e, option) => {
                      this.props.editState({porDataScale: option.text})
                      this.changeFilter({type: option.key}, 'type');
                    }}
                    options={ availableFilters.types.map(({type_id, type, unit}) => ({key: type_id, text: `${type} (${unit})`})) }
                  />
                  <Dropdown
                    label="Base Alternative:"
                    placeHolder="Select a Base Alternative"
                    className={ this.props.baseAlt ? 'heat-map-filter' : 'heat-map-filter empty'}
                    disabled={!this.props.type}
                    id="location-dropdown-filter-single"
                    selectedKey={this.props.baseAlt}
                    onChange={(e, option) => this.props.editState({baseAlt: option.key})}
                    options={ availableFilters.baseAlts.map(({alternative_id, short_name}) => ({key: alternative_id, text: short_name})) }
                  />
                  <Dropdown
                    label="Compared Alternative:"
                    placeHolder="Select a Comp Alternative"
                    className={this.props.compAlt ? 'heat-map-filter' : 'heat-map-filter empty'}
                    disabled={!this.props.baseAlt}
                    id="location-dropdown-filter-single"
                    selectedKey={this.props.compAlt}
                    onChange={(e, option) => this.props.editState({compAlt: option.key})}
                    options={ availableFilters.compAlts.map(({alternative_id, short_name}) => ({key: alternative_id, text: short_name})) }
                  />
                  <DefaultButton
                    className='apply-filter'
                    text="Apply"
                    primary
                    onClick={ () => this.applyFilters() }
                  />
                </div>
              ) : (
                <Loading label='Loading Filters...'/>
              )
            }
          </div>
          <div className='stats-summary default-shadow'>
            <div className='flex-column space-between'>
              <p style={{textAlign: 'center'}}>Click on the chart for more details</p>
              {
                statsSummary.noData ? (
                  <p>No data found at selection</p>
                ) : statsSummary.x && statsSummary.y ? (
                  <div>
                    <table style={{width: '100%'}}>
                      <tbody>
                        <tr>
                          <td>Year:</td>
                          <td>{statsSummary.y || ' '}</td>
                        </tr>
                        <tr>
                          <td>Date:</td>
                          <td>{(statsSummary.x).toString() || ' '}</td>
                        </tr>
                        <tr>
                          <td>Base Alternative:</td>
                          <td>{(statsSummary.base).toString() || ' '}</td>
                        </tr>
                        <tr>
                          <td>Compared Alternative:</td>
                          <td>{(statsSummary.comp).toString() || ' '}</td>
                        </tr>
                        <tr>
                          <td>Absolute Difference:</td>
                          <td>{ (statsSummary.zAbs || statsSummary.zAbs === 0) ? `${(parseFloat(statsSummary.zAbs)).toFixed(2)}` : ' '}</td>
                        </tr>
                        <tr>
                          <td>Percentage Difference:</td>
                          <td>{ (statsSummary.z || statsSummary.z === 0) ? `${(parseFloat(statsSummary.z) * 100).toFixed(2)}%` : ' '}</td>
                        </tr>
                      </tbody>
                    </table>
                    <DefaultButton
                      className='apply-filter'
                      style={{width: '100%', marginTop: '4px'}}
                      text="Open Chart"
                      disabled={!this.props.statsSummary.x || !this.props.statsSummary.y}
                      primary
                      onClick={ () => this.props.history.push(`/charts/Multiple Alternative/${this.props.source}/${this.props.river}/${this.props.type}/${this.props.location}/${this.props.baseAlt}&${this.props.compAlt}/${this.props.statsSummary.y}/${this.props.porDataScale}`) }
                    />
                  </div>
                ) : null
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
	return {
    filters: state.multi.filters,
    hoverMap: state.multi.hoverMap,
    ...state.por
  }
};

const mapDispatchToProps = dispatch => {
	return {
    editState: (changes) => dispatch(actions.editState(changes)),
    setMap: (river) => dispatch(actions.setMap(river))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Por);



// WEBPACK FOOTER //
// ./src/containers/Por.js